<template>
  <div id="page-calendar" class="page-container">
    <span class="app-header">
      <UsersIcon class="app-header-icon" />
      <span class="app-header-text">{{title}}</span>
    </span>
    <div class="container viewport-container">
      <div class="page-tabs">
        <button class="link" :class="{active: pageTabId === 1}" @click="allFriendsTabClick">Все</button>
        <span class="not-selectable">/</span>
        <button class="link" :class="{active: pageTabId === 2}" @click="incomingFriendsTabClick">Запросы</button>
        <span class="not-selectable">/</span>
        <button class="link" :class="{active: pageTabId === 3}" @click="requestedFriendsTabClick">Исходящие</button>
      </div>
      <div class="tab-content" v-if="pageTabId === 1">
        <div v-if="allFriendsTab_loader" class="group-data-loader">
          <spinner/>
        </div>
        <alert-label v-else-if="!friendList || !friendList.length" :closable="false" :fullWidth="false" color="" textAlign="left">
          В настоящий момент друзей нет, но это легко исправить! Поделитесь QR кодом со станицы профиля с вашим кругом общения. Находите новых друзей среди событий и мероприятий в <a href="/calendar" class="link">Календаре</a>.
        </alert-label>
        <div v-else class="list-container" ref="itemList">
          <!-- список друзей -->
          <ul class="item-list">
            <li v-for="item in friendList" :key="item.id">
              <!-- <UserFriendCard :item="item"/> -->
            </li>
          </ul>
        </div>
      </div>
      <div class="tab-content" v-if="pageTabId === 2">
        <div v-if="incomingRequestList_loader" class="group-data-loader">
          <spinner/>
        </div>
        <alert-label v-else-if="!incomingRequestList || !incomingRequestList.length" :closable="false" :fullWidth="false" color="blue" textAlign="left">
          Запросов в друзья пока нет.
        </alert-label>
        <div v-else class="list-container" ref="itemList">
          <!-- Todo -->
        </div>
      </div>
      <div class="tab-content" v-if="pageTabId === 3">
        <div v-if="outgoingRequestList_loader" class="group-data-loader">
          <spinner/>
        </div>
        <alert-label v-else-if="!outgoingRequestList || !outgoingRequestList.length" :closable="false" :fullWidth="false" color="blue" textAlign="left">
          Исходящих запросов дружбы нет.
        </alert-label>
        <div v-else class="list-container" ref="itemList">
          <!-- Todo -->
        </div>
      </div>
    </div>
    <confirm-dialogue :theme="$store.state.theme" ref="confirmationDialogue"/>
    <action-dialogue :theme="$store.state.theme" ref="listItemActionDialogue" />
    <action-dialogue :theme="$store.state.theme" ref="userProfileDialogue" @close="userProfileDialogueClosed">
      <template v-slot:content>
        <div v-if="showUserProfileModal_loader" class="group-data-loader">
          <spinner/>
        </div>
        <div v-else-if="showUserProfileModal_userData">
          <div class="avatar-container">
            <AvatarCircle
              :size="200"
              :username="showUserProfileModal_userData.fullName"
              :readonly="true"
              :src="$host.host + showUserProfileModal_userData.avatarUrl"/>
          </div>
          <div v-if="showUserProfileModal_userData.id == $store.state.userId">
            <alert-label :closable="false" :fullWidth="true" color="none" textAlign="center">
              Это Ваш профиль!
            </alert-label>
          </div>
          <div v-else>
            <text-box
              :value="showUserProfileModal_userData.fullName"
              showSeparator
              readonly
            />
            <alert-label v-if="showUserProfileModal_userData.isFriend" :closable="false" :fullWidth="true" color="green" textAlign="center">
              Уже в друзьях!
            </alert-label>
            <alert-label v-if="showUserProfileModal_userData.isBlocked" :closable="false" :fullWidth="true" color="green" textAlign="center">
              Пользователь Вас заблокировал!
            </alert-label>
            <div v-else-if="showUserProfileModal_userData.canBeFriend">
              <button class="btn blue align-center" @click="sendFriendshipRequestClick">Добавить в друзья</button>
            </div>
          </div>
        </div>
        <div v-else>
          <error-alert
            message="Не удалось загрузить профиль профиля."
          />
        </div>
        <br>
        <button class="btn blue align-center" @click="$refs.userProfileDialogue.close()">Закрыть</button>
      </template>
    </action-dialogue>
  </div>
</template>

<script>

import ActionDialogue from '@/components/ActionDialogue.vue';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue';

export default {
  components: {
    ActionDialogue,
    ConfirmDialogue,
  },
  computed: {
    title() { return document.title; },
  },
  data: function () {
    return {
      allFriendsTab_loader: false,
      incomingRequestList_loader: false,
      outgoingRequestList_loader: false,
      friendList: [],
      incomingRequestList: [],
      outgoingRequestList: [],
      friendCounters: {
        friends: 0,
        incoming: 0,
        requested: 0
      },
      pageTabId: 1,
      showUserProfileModal_loader: false,
      showUserProfileModal_userId: null,
      showUserProfileModal_userData: null
    }
  },
  methods: {
    allFriendsTabClick() {
      if (this.pageTabId === 1) return;
      this.pageTabId = 1;
    },
    incomingFriendsTabClick() {
      if (this.pageTabId === 2) return;
      this.pageTabId = 2;
    },
    requestedFriendsTabClick() {
      if (this.pageTabId === 3) return;
      this.pageTabId = 3;
    },
    loadFriends() {

    },
    userProfileDialogueClosed() {
      this.showUserProfileModal_userId = null;
      this.showUserProfileModal_userData = null;

      const newPathObject = {
        pathname: this.$route.path,
        query: {}
      }

      try {
        this.$router.push(newPathObject, undefined, { shallow: true });
      }
      catch(e) { }
    },
    showUserProfileModal(userId) {
      this.showUserProfileModal_loader = true;
      this.showUserProfileModal_userId = userId;
      this.showUserProfileModal_userData = null;

      this.$refs.userProfileDialogue.show({
        title: 'Профиль пользователя',
        htmlContent: null,
        content: null,
        cancelButton: null
      });

      // GetProfileByUserId
      this.$http.get(`${this.$host.UserServiceApi}`, { params: {userId}})
      .then((response) => {
        const resultData = response.body;
        if (this.showUserProfileModal_userId === resultData.id) {
          this.showUserProfileModal_userData = resultData;
          this.showUserProfileModal_loader = false;
        }
      })
      .catch((e) => {
        this.showUserProfileModal_loader = false;
      })
    },
    readRouteParams() {
      const p = new URLSearchParams(this.$route.query);
      if (p.has('show-user-id') && p.get('show-user-id') !== null) {
        const userId = p.get('show-user-id');
        window.requestAnimationFrame(() => {
          this.showUserProfileModal(userId);
        });
      }
    }
  },
  created() {
    this.loadFriends();
    this.readRouteParams();
  }
}
</script>

<style scoped>
.page-tabs {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-end;
  margin-bottom: 1rem;
}
.page-content {

}
</style>